import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import MakeOfferModal from "../modals/MakeOfferModal";
import LcaCardQuestions from "./LcaCardsQuestions";
import LcaCardsEvents from "./LcaCardsEvents";
import "./LcaCards.css";
import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data";
import { initiateCall, makeCall, sendMsgMail } from "../Data";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  UncontrolledTooltip,
} from "reactstrap";
import {
  setSelectedAd,
  setSkippedAd,
  setTooltipOpen,
} from "../../../redux/slices/LcaSlice";
import GitHubForkRibbon from "react-github-fork-ribbon";
import SkipModal from "./SkipModal";
import axiosClient from "../../../axios-client";
import {
  setIsChatModalOpen,
  setSampleAd,
} from "../../../redux/slices/SearchBarSlice";
import DOMPurify from "dompurify";
import LcaActionButtons from "./LcaActionButtons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import OnlineStatus from "../../Layout/onlineStatus";

const LcaBox = ({ ad }) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const { onlineView } = useSelector((state) => state.lcaAndVendors);
  const [schedule, setSchedule] = useState(false);
  const navigate = useNavigate();
  const tooltipRef = useRef();
  const buttonRef = useRef();
  const [questionsVisible, setQuestionsVisible] = useState({});
  const [eventsVisible, setEventsVisible] = useState({});
  const [popupImage, setPopupImage] = useState(null);
  const isAdmin = user && user.Role === "admin";
  const swiperRef = useRef(null);
  const { selectedAd } = useSelector((state) => state.lcAds);
  const {
    isChatModalOpen,
    actionClickStatus,
    actionClickError,
    checkExistingError,
    checkExistingStatus,
  } = useSelector((state) => state.searchBar);
  const [openSkipModal, setOpenSkipModal] = useState(false);

  const images =
    ad.Photo && JSON.parse(ad.Photo).length > 0
      ? JSON.parse(ad.Photo)
      : [PlaceHolder];
  console.log(images, "images");
  const parsedImages = Array.isArray(images)
    ? images
    : typeof images === "string"
    ? JSON.parse(images)
    : [];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        dispatch(setTooltipOpen(false));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const stripHtml = (html) => {
    const cleanHtml = DOMPurify.sanitize(html || "No description available", {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    });
    const doc = new DOMParser().parseFromString(cleanHtml, "text/html");
    return doc.body.textContent || "";
  };

  const truncateText = (text, maxLength = 200) => {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}...`;
    }
    return text;
  };

  // const isAdInMyOffers = (ad) => {
  //   const offers = ad?.approveProviderId;
  //   const parseIds = offers?.split(",").map(Number);
  //   return parseIds?.includes(user?.UserID);
  // };

  // const isAlreadyGotton = (ad) => {
  //   const offers = ad?.approveProviderId;
  //   const parseIds = offers?.split(",").map(Number);
  //   return parseIds?.length >= 5;
  // };

  const handleCardClick = (selectedCard) => {
    const screenWidth = window.innerWidth;
    const isIpadPro = screenWidth === 1024;
    if (!isChatModalOpen && !isOfferModalOpen) {
      if (selectedCard.engagedCouple === 1) {
        if (isIpadPro) {
          navigate(`/engagedCouple/${selectedCard.createdBy}`);
        } else {
          window.open(`#/engagedCouple/${selectedCard.createdBy}`, "_blank");
        }
      } else {
        if (isIpadPro) {
          navigate(`/requestDetails/${selectedCard.Id}`);
        } else {
          window.open(`#/requestDetails/${selectedCard.Id}`, "_blank");
        }
      }
    }
  };

  const closeModal = () => {
    dispatch(setIsChatModalOpen(false));
    setIsOfferModalOpen(false);
    dispatch(setSampleAd(null));
    setSchedule(false);
  };

  const openOfferModal = (event, ad) => {
    event.stopPropagation();
    if (!islogin) {
      toast.info("Please Login To Get Customer!..");
    } else {
      setIsOfferModalOpen(true);
      dispatch(setSelectedAd(ad));
    }
  };

  function formatDate1(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  const now = new Date();
  const formattedDate = formatDate1(now);

  const handleIndiviualCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
      userTo: ad?.createdBy,
      userFrom: user?.UserID,
      callType: 1, //1 for phone,2 for voip,3 for zoom
      userToPhone: phoneDetails,
      userFromPhone: `${user?.CountryCode}${user?.Phone}`,
      typeId: ad?.Id,
      Type: "need",
    };
    toast.success("Call send to your Mobile please respond");
    await initiateCall(formData);
  };

  const toggleEvents = (event, ad) => {
    event.stopPropagation();
    const currentQuestionsVisible = questionsVisible[ad.Id] || false;
    const currentEventsVisible = eventsVisible[ad.Id] || false;
    if (currentQuestionsVisible) {
      setQuestionsVisible({ ...questionsVisible, [ad.Id]: false });
    }
    const updatedEventsVisible = {};
    Object.keys(eventsVisible).forEach((cardId) => {
      updatedEventsVisible[cardId] =
        cardId === ad.Id ? !currentEventsVisible : false;
    });
    setEventsVisible({
      ...updatedEventsVisible,
      [ad.Id]: !currentEventsVisible,
    });
  };

  const toggleQuestions = (event, ad) => {
    event.stopPropagation();
    const currentQuestionsVisible = questionsVisible[ad.Id] || false;
    const currentEventsVisible = eventsVisible[ad.Id] || false;
    if (currentEventsVisible) {
      setEventsVisible({ ...eventsVisible, [ad.Id]: false });
    }
    const updatedQuestionsVisible = {};
    Object.keys(questionsVisible).forEach((cardId) => {
      updatedQuestionsVisible[cardId] =
        cardId === ad.Id ? !currentQuestionsVisible : false;
    });
    setQuestionsVisible({
      ...updatedQuestionsVisible,
      [ad.Id]: !currentQuestionsVisible,
    });
  };

  function convertTo12HourFormat(time24) {
    if (!time24) {
      return "";
    }
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) {
      return "";
    }
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0");
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  function formatDate(inputDate) {
    let date = new Date(inputDate);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    let formattedDay = day < 10 ? "0" + day : day;
    let formattedDate = `${month} ${formattedDay}, ${year}`;
    return formattedDate;
  }

  function convertToUserTimezone(utcTime) {
    let timezone = "America/Los_Angeles";
    if (islogin && user?.TimeZone) {
      timezone = user?.TimeZone.split(",")[0];
    }
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    return localTime;
  }

  const [timeLeft, setTimeLeft] = useState(null);
  const [isOneHourLeft, setIsOneHourLeft] = useState(false);

  useEffect(() => {
    const adCreationTime = new Date(ad.approvedAt);
    const currentTime = new Date();
    const timeDifference = currentTime.getTime() - adCreationTime.getTime();

    if (timeDifference > 24 * 60 * 60 * 1000) {
      setTimeLeft("00:00:00");
    } else {
      const remainingTime = 24 * 60 * 60 * 1000 - timeDifference;
      const hours = Math.floor(remainingTime / (60 * 60 * 1000));
      const minutes = Math.floor(
        (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
      );
      const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

      setTimeLeft(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );

      setIsOneHourLeft(hours <= 1);
    }

    const intervalId = setInterval(() => {
      const adCreationTime = new Date(ad.approvedAt);
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - adCreationTime.getTime();

      if (timeDifference > 24 * 60 * 60 * 1000) {
        setTimeLeft("00:00:00");
      } else {
        const remainingTime = 24 * 60 * 60 * 1000 - timeDifference;
        const hours = Math.floor(remainingTime / (60 * 60 * 1000));
        const minutes = Math.floor(
          (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
        );
        const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

        setTimeLeft(
          `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        );

        setIsOneHourLeft(hours <= 1);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [ad.approvedAt]);

  const handleSkip = async (event, ad) => {
    event.stopPropagation();
    if (!islogin) {
      toast.info("Please Login To Skip Customer!..");
      return;
    }
    if (ad?.needSkipCustomer == 0 || isAdmin) {
      dispatch(setSelectedAd(ad));
      setOpenSkipModal(true);
    } else {
      const updatedAd = { ...ad, needSkipCustomer: 0 };
      dispatch(setSkippedAd(updatedAd));

      try {
        const formData = {
          needId: ad.Id,
          skipStatus: 0,
          createdBy: user?.UserID,
        };
        const response = await axiosClient.post(
          "need/UndoSkipCustomer",
          formData
        );
        if (response.data.statusCode === 200) {
          toast.success("Ad unskipped successfully!");
        } else {
          dispatch(setSkippedAd(ad));
          toast.error(response.data.msg || "Failed to unskip ad");
        }
      } catch (error) {
        dispatch(setSkippedAd(ad));
        toast.error("Error unskipping ad");
        console.error("Error:", error);
      }
    }
  };

  useEffect(() => {
    if (actionClickStatus === "failed" && actionClickError) {
      toast.error(actionClickError);
    }
  }, [actionClickStatus, actionClickError]);

  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  return (
    <>
      <Card className="shadow-sm position-realtive d-block">
        {ad?.caidStatus === 100 ? (
          <GitHubForkRibbon color="green" position="left">
            Verified & Trusted
          </GitHubForkRibbon>
        ) : null}
        <Row className="g-0">
          <Col
            lg="3"
            md="3"
            className="d-flex align-items-center justify-content-center"
          >
            <div
              className="image-container "
              style={{
                overflow: "hidden",
                width: "100%",
                height: "300px",
                borderRadius: "0.5rem",
              }}
              onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
              onMouseLeave={() => swiperRef.current?.autoplay?.start()}
            >
              {!popupImage && (
                <div
                  className="position-absolute"
                  style={{
                    backgroundColor: "white",
                    width: "auto",
                    padding: "0 2px 2px 0",
                    zIndex: 2,
                  }}
                >
                  <img
                    style={{
                      width: "18px",
                    }}
                    src={ad?.profilePhoto ? ad?.profilePhoto : PlaceHolder}
                    alt={ad?.firstName}
                  />
                </div>
              )}
              <Swiper
                modules={[Autoplay]}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                }}
                speed={4000}
                loop={images.length > 1}
                spaceBetween={0}
                slidesPerView={1}
                style={{ height: "100%", width: "100%" }}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                onTouchStart={() => swiperRef.current?.autoplay?.stop()}
                onTouchEnd={() => swiperRef.current?.autoplay?.start()}
              >
                {parsedImages.length > 0 &&
                  parsedImages.map((imgSrc, idx) => (
                    <SwiperSlide
                      key={idx}
                      style={{ height: "100%", width: "100%" }}
                    >
                      <img
                        src={imgSrc || PlaceHolder}
                        alt={`Image ${idx}`}
                        className="wc_egcpl-ad"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "0.25rem",
                        }}
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = PlaceHolder;
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPopupImage(imgSrc);
                        }}
                      />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </Col>

          <Col lg="7" md="7">
            <CardBody
              onClick={() => handleCardClick(ad)}
              className="lca-card-body"
            >
              {/* <OnlineStatus createdBy={ad?.createdBy} /> */}
              <CardTitle
                tag="h5"
                className="mb-2 d-flex  gap-2 align-items-center"
                style={{
                  fontSize: "large",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <b>
                  {ad.Title.length > 100
                    ? `${ad.Title.substring(0, 100)}...`
                    : ad.Title}
                </b>
                {/* {onlineView && (
                  <span className="mt-1">
                    <OnlineStatus createdBy={ad?.createdBy} />
                  </span>
                )} */}
              </CardTitle>
              <CardText
                style={{
                  fontSize: "medium",
                  marginLeft: 0,
                }}
                className="plain-description"
              >
                {truncateText(stripHtml(ad.Description))}
              </CardText>
              <div className="mb-1">
                <CardText
                  className="text-nowrap mx-0"
                  style={{ fontSize: "medium" }}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span> {ad.Zipcode}</span> -{" "}
                  <span className=""> {ad.placeName}</span>
                </CardText>
                {ad.subCategoryName && (
                  <CardText className="fs-6 ">
                    <b>Service Needed:</b>{" "}
                    {ad.itemName
                      ? ad.itemName
                      : ad.subCategoryName
                      ? ad.subCategoryName
                      : ad.categoryName}
                  </CardText>
                )}
              </div>
              <div>
                <p className="mb-0 posting" style={{ fontSize: "small" }}>
                  Posting Date/Time:{" "}
                  {formatDate(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[0]
                  )}
                  {convertTo12HourFormat(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[1]
                  )}
                </p>
              </div>
            </CardBody>
          </Col>
          <Col
            lg="2"
            md="2"
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <LcaActionButtons
              ad={ad}
              handleIndiviualCall={handleIndiviualCall}
              toggleEvents={toggleEvents}
              toggleQuestions={toggleQuestions}
              openOfferModal={openOfferModal}
              handleSkip={handleSkip}
              buttonRef={buttonRef}
              tooltipRef={tooltipRef}
              timeLeft={timeLeft}
              questionsVisible={questionsVisible}
              eventsVisible={eventsVisible}
            />
          </Col>
        </Row>
        {questionsVisible[ad.Id] && (
          <CardBody>
            <LcaCardQuestions ad={ad} />
          </CardBody>
        )}
        {eventsVisible[ad.Id] && (
          <CardBody>
            <LcaCardsEvents ad={ad} />
          </CardBody>
        )}
      </Card>
      {popupImage && (
        <div
          className="image-popup-overlay"
          onClick={() => setPopupImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="popup-box"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              backgroundColor: "#fff",
              padding: "1rem",
              borderRadius: "0.5rem",
              maxWidth: "80vw",
              maxHeight: "80vh",
              boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
            }}
          >
            <button
              onClick={() => setPopupImage(null)}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-1px",
                background: "#9c27b0",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "32px",
                fontSize: "20px",
                cursor: "pointer",
              }}
              aria-label="Close image popup"
            >
              ×
            </button>
            <img
              src={popupImage}
              alt="Zoomed"
              style={{
                maxWidth: "100%",
                maxHeight: "65vh",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
      {isOfferModalOpen && (
        <MakeOfferModal
          isOpen={isOfferModalOpen}
          closeModal={closeModal}
          selectedCard={selectedAd}
          setSchedule={setSchedule}
          schedule={schedule}
          timeLeft={timeLeft}
        />
      )}
      {openSkipModal && (
        <SkipModal
          open={openSkipModal}
          close={() => setOpenSkipModal(false)}
          ad={ad}
        />
      )}
    </>
  );
};

export default LcaBox;
